enum ShowPdfTypes {
  JOB = 'JOB',
  SERVICE = 'SERVICE',
  INVOICE = 'INVOICE'
}

export default ShowPdfTypes;
